export default {
    namespaced: true,
    state: {

        //Marca
        brand:{
            name:'LF Soluciones',
            slogan:'Plomero y gasista',
            email: 'info@lfsoluciones.com.ar', // Para el servidor usar de email usar el password: 3610410543aA$q 
            emailUrl: 'lfsoluciones.com.ar',
            phone: '+54 221 6382-108',

            urlWebForImgEmail: 'https://lfsoluciones.com.ar',
            whatsappUrl: 'https://wa.me/542216382108',
            phoneUrl: 'tel:+542216382108',
            urlIG:'https://www.instagram.com/lfsolucionesok',
            urlFB:'https://www.facebook.com/lfsolucionesok'
        },

    },

    mutations: {

    },

    actions: {

    },
    getters:{
        
    }
}